const STATUSES = ['READY', 'NO_RECIPE', 'PROFILE_CHANGED', 'STRUCTURE_MISMATCH'];

export function isPemetaanProfile(profile) {
    return String(profile.kodeTipeCbt || profile.kodeSubTipeCbt || '').startsWith('PEMETAAN');
}

export function readPemetaanReadiness(body, profileId) {
    const data = body && body.data;
    if (!body || !body.errorSchema || body.errorSchema.errorCode !== 'EP-000' || !data
        || Number(data.profileId) !== Number(profileId) || !isPemetaanProfile(data)
        || !Array.isArray(data.variants) || data.variants.length !== 3
        || data.variants.some(row => !row || typeof row !== 'object')) return null;
    const variants = data.variants.map(row => ({urutan: Number(row.urutan), status: row.status}));
    if ([1, 2, 3].some(urutan => variants.filter(row => row.urutan === urutan).length !== 1)
        || variants.some(row => !STATUSES.includes(row.status))) return null;
    return variants.sort((a, b) => a.urutan - b.urutan);
}

export function pemetaanStatusText(status) {
    if (status === 'READY') return 'Konfigurasi siap';
    if (status === 'NO_RECIPE') return 'Konfigurasi belum disetujui';
    if (status === 'PROFILE_CHANGED') return 'Isi profil berubah, perlu diperiksa kembali';
    if (status === 'STRUCTURE_MISMATCH') return 'Struktur profil belum sesuai';
    return 'Konfigurasi belum diperiksa';
}

export function pemetaanNextStep(status) {
    if (status === 'NO_RECIPE') return 'Minta persetujuan konfigurasi untuk profil ini kepada pengelola sebelum membuat jadwal.';
    if (status === 'PROFILE_CHANGED') return 'Minta pengelola memeriksa isi profil dan mengajukan persetujuan ulang.';
    if (status === 'STRUCTURE_MISMATCH') return 'Minta pengelola memeriksa struktur profil untuk jenis ini.';
    return '';
}
